import React, { memo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import useMediaQuery from '@mui/material/useMediaQuery'
import Image from 'components/shared/Image'
import ImageBanner from 'public/img/easy/Img_Banner_section_three_desk.webp'
import ImageBannerMobile from 'public/img/easy/Img_section_three_Banner_Mobile.webp'
import EasyAgenciasImageBanner from 'public/img/easy/Img_Nosotrostetraemosventas.webp'
import EasyAgenciasImageBannerMobile from 'public/img/easy/Img_Nosotrostetraemosventas_mobile.webp'
import sx from './styles'

function PotentialBuyers(props) {
  const {
    title = 'EASY_SECTION_THREE_TITLE',
    subtitle = 'EASY_NO_MATTER_WHO_THE_BUYER_IS',
    isEasyAgencias = false,
  } = props
  const { formatMessage: f } = useIntl()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))

  return (
    <Box sx={sx.root}>
      <Grid
        container
        sx={sx.containerElements}
        borderRadius={4}
      >
        <Grid
          size={12}
          sx={sx.title}
        >
          <Typography
            component="h2"
            align="center"
            variant="h1"
          >
            <FormattedMessage id={title} />
          </Typography>
        </Grid>

        <Grid size={12}>
          <Typography
            component="h3"
            sx={sx.subtitle}
            align="center"
            variant="h2"
          >
            <FormattedMessage id={subtitle} />
          </Typography>

        </Grid>

        {
          isMobile
            ? (
              <Grid
                size={12}
                style={sx.mainBanner}
              >
                <Image
                  title={f({ id: 'EASY_SECTION_THREE_TITLE' })}
                  src={(isEasyAgencias ? EasyAgenciasImageBannerMobile : ImageBannerMobile) ?? ''}
                  placeholder="blur"
                  alt={f({ id: 'EASY_SECTION_THREE_TITLE' })}
                  width="100%"
                  height="330px"
                  priority
                  unoptimized
                />
              </Grid>
            )
            : (
              <Grid
                size={12}
                style={sx.mainBanner}
              >
                <Image
                  title={f({ id: 'EASY_SECTION_THREE_TITLE' })}
                  src={isEasyAgencias ? EasyAgenciasImageBanner : ImageBanner}
                  placeholder="blur"
                  alt={f({ id: 'EASY_SECTION_THREE_TITLE' })}
                  width="100%"
                  height="300px"
                  priority
                  unoptimized
                />
              </Grid>
            )
        }
      </Grid>
    </Box>
  )
}

export default memo(PotentialBuyers)
